import { defineMessages } from 'react-intl';


export default defineMessages({
  addPhotosphereLabel: {
    id: 'app.containers.Photosphere.UploadImage.Label',
    defaultMessage: 'Adicionar mais fotos',
  },
  clickToUploadPhotoLabel: {
    id: 'app.containers.Photo.UploadImage.ClickToUploadLabel',
    defaultMessage: 'Clique para adicionar as fotos',
  },
  clickToUploadLabel: {
    id: 'app.containers.Photosphere.UploadImage.ClickToUploadLabel',
    defaultMessage: 'Clique para adicionar as fotos 360',
  },
  dragAndDropLabel: {
    id: 'app.containers.Photosphere.UploadImage.DragAndDropLabel',
    defaultMessage: 'ou arraste e solte as fotos aqui',
  },
});
